import "./scss/main.scss";
import { useHistory } from "react-router-dom";
import { useState, useEffect, ChangeEventHandler } from "react";
import AdminCompanyModal from "../components/AdminCompanyModal";
import AdminLoginKeyboard from "../components/AdminLoginKeyboard";
import AdminKeyboard from "../components/AdminKeyboard";
import axiosInstance from "../api/axiosInstance";
import { useDispatch } from "react-redux";
import AlertModal from "../components/AlertModal";
import { kioskInfo } from "../actions/authActions";
import AdminLoginModal from "../components/AdminLoginModal";
import { CompanyInfoRequest, CompanyInfoResponse } from "../types/CompanyTypes";
// import PromotionModal from "../components/PromotionModal";
import { store } from "../store/store";

declare global {
  interface Window {
    getCompanyId: any; // 원하는 타입으로 설정
    setCompanyInfo: any;
    failLoadSetting: any
    chrome: any
  }
}

const alertInfoType = {
  alertShow: false,
  title: '',
  content: ''
}

const adminKeyboardBasic = {
  adminLoginShow: false,
  admingLoginKeyboardShow: false,
  keyboardShow: false
}

interface keyboardType {
  companyLoginId: string,
  keyboardLayout: string
}

const Main: React.FC = () => {
  const dispatch = useDispatch();
  window.setCompanyInfo = setCompanyInfo;
  window.getCompanyId = getCompanyId;
  window.failLoadSetting = failLoadSetting;
  const [time, setTime] = useState<string>("");
  const [companyLoginInfo, setCompanyLoginInfo] = useState<keyboardType>({ companyLoginId: '', keyboardLayout: 'default' })
  const [alertInfo, setAlertInfo] = useState(alertInfoType);
  const [companyId, setRootCompanyId] = useState("");
  const [tid, setTid] = useState("");
  const [adminKeyboard, setAminKeyboard] = useState(adminKeyboardBasic)
  const history = useHistory();
  const getCurrentDateTimeString = () => {
    const days = ["일", "월", "화", "수", "목", "금", "토"];
    const now = new Date();
    const month = now.getMonth() + 1; // getMonth()는 0부터 시작하므로 +1을 해줍니다.
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const dayOfWeek = days[now.getDay()]; // getDay()는 0(일요일)부터 6(토요일)까지의 숫자를 반환합니다.

    // 문자열로 조합
    const dateTimeString = `${month}/${day}(${dayOfWeek}) ${hours}:${minutes}`;

    return dateTimeString;
  };

  const Time = () => {
    setTime(getCurrentDateTimeString());
  };

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = async () => {

    history.push("/search");
    // if (!companyId) getCompanyId();
    // else history.push("/search");
    // history.push({pathname : '/search',state:{companyId : companyId}})
  };

  function setCompanyInfo(props: any) {
    console.log('set', props)
    dispatch(kioskInfo(props))
  }

  function failLoadSetting() {
    setAlertInfo({
      alertShow: true,
      title: '설정값 오류',
      content: '관리자 설정 중 오류가 발생했습니다. 다시 시도해주세요.'
    })
  }

  function getCompanyId() {
    // setAminKeyboard(prev => ({
    //   ...prev,
    //   adminShow: true
    // }))

    setAminKeyboard({
      admingLoginKeyboardShow: true,
      adminLoginShow: true,
      keyboardShow: false
    })
  }

  const onCallback = (props: any) => {
    console.log(props)
    setRootCompanyId(props.companyId)
    setTid(props.tid)

    setAminKeyboard(prev => ({
      ...prev,
      keyboardShow: true
    }))
  }

  const onKeyboardCallback = async (props: any) => {
    console.log(props)
    await axiosInstance()
      .post(`/kiosk/adminSameCheck.do`, {
        companyId: companyId,
        userId: props.userId,
        kioskLoginPwd: props.userPassword,
      }).then((res) => {
        console.log(companyId)
        if (res.data.resultCode === '0') {
          window.chrome.webview.postMessage({
            types: [
              { type: "cd", data: String(companyId) },
              { type: "user", data: props.userId },
              { type: "tid", data: tid }
            ]
          });
          setAminKeyboard({
            admingLoginKeyboardShow: false,
            adminLoginShow: false,
            keyboardShow: false
          })
        } else {
          setAlertInfo({
            alertShow: true,
            title: '로그인 실패',
            content: `${res.data.resultMsg}`
          })
        }
      })
  }

  const selCompanyIdByLoginId = async () => {
    await axiosInstance()
      .post<CompanyInfoRequest, CompanyInfoResponse>('/kiosk/selectCompanyByLoginId.do', {
        loginId: companyLoginInfo.companyLoginId
      }).then((res) => {
        console.log(res)
        if (res.data.status === 200) {
          setRootCompanyId(String(res.data.data.companyId));
          setAminKeyboard({
            adminLoginShow: false,
            admingLoginKeyboardShow: false,
            keyboardShow: true
          })
          window.sessionStorage.setItem("companyLogin", "true");
        } else {
          setAlertInfo({
            alertShow: true,
            title: '로그인 실패',
            content: `${res.data.resultMsg}`
          })
        }
      })
  }

  const selCompanyIdBySubdomain = async () => {
    const parts = window.location.hostname.split('.');

    await axiosInstance()
      .post<CompanyInfoRequest, CompanyInfoResponse>('/kiosk/selectCompanyByLoginId.do', {
        loginId: parts[0]
      }).then((res) => {
        console.log(res)
        if (res.data.status === 200) {
          setRootCompanyId(String(res.data.data.companyId));
          setAminKeyboard({
            adminLoginShow: false,
            admingLoginKeyboardShow: false,
            keyboardShow: true
          })
          window.sessionStorage.setItem("companyLogin", "true");
        } else {
          setAlertInfo({
            alertShow: true,
            title: '로그인 실패',
            content: `${res.data.resultMsg}`
          })
        }
      })
  }

  const onKeyPress: ChangeEventHandler<HTMLElement> = (event) => {

    console.log(event)
    // 쉬프트 버튼 눌렀을 때
    if (String(event) === '{shift}') {
      setCompanyLoginInfo(prev => ({
        ...prev,
        keyboardLayout: 'shift'
      }))
      // 대문자 키패드에서 쉬프트 눌렀을 때
    } else if (String(event) === '{shiftactivated}') {
      setCompanyLoginInfo(prev => ({
        ...prev,
        keyboardLayout: 'default'
      }))
    }
    else if (String(event) === '{bksp}') {
      setCompanyLoginInfo(prev => ({
        ...prev,
        companyLoginId: prev.companyLoginId.slice(0, -1)
      }))
    }
    // 문자나 숫자 입력시에는 TEXT 합치기
    else {
      setCompanyLoginInfo(prev => ({
        ...prev,
        companyLoginId: prev.companyLoginId + event
      }))
    }
  }

  useEffect(() => {
    const companyLogin = window.sessionStorage.getItem("companyLogin");
    const parts = window.location.hostname.split('.');

    if (parts.length >= 4 && companyLogin == null) { // 서브도메인 포함, 업체 로그인 안했을 때
        selCompanyIdBySubdomain();
    }

    store.dispatch({
      type: "LOADED",
    });

    dispatch({ type: "DRIVER_CLEAR" });
    dispatch({ type: "RESERVATION_ONE" });
    dispatch({ type: "PRODUCT" });
    dispatch({ type: "PRODUCT_RESET" });

    // const timeIntervalId = setInterval(Time, 1000);

    const checkHourlyRefresh = () => {
      const now = new Date();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();

      if (minutes === 0 && seconds === 0) {
        window.location.reload();
      }
    };

    const hourlyRefreshIntervalId = setInterval(checkHourlyRefresh, 1000);

    return () => {
      //clearInterval(timeIntervalId);
      clearInterval(hourlyRefreshIntervalId);
    };
  }, []);

  return (
    <>
      <div className="main-wrap">
        <div className="box-wrap">
          <div
            className="temp-img"
            style={{ backgroundImage: 'url("/img/Rectangle.svg")' }}
          ></div>
          {/* <img src="/img/Rectangle.svg"></img> */}
        </div>
        <div className="dec-wrap">
          <span className="dec">렌터카 키오스크</span>
          {/* <span className="time">{time}</span> */}
        </div>

        <div style={{ height: "4%" }}></div>
        <div className="title-wrap">
          <h1 className="title">
            렌트카 무인배차로
            <br /> 차량 인수를 간편하게!
          </h1>
          <span className="sub-title">
            예약조회 버튼을 눌러 서비스를 이용하세요.
          </span>
        </div>
        <div style={{ height: "4%" }}></div>
        <div className="submit-wrap">
          <button onClick={handleClick}>예약조회</button>
        </div>
        <div style={{ height: "4%" }}></div>
        <div className="dec-img-wrap">
          <img src="/img/li.svg" alt="" />
          <img src="/img/li-1.svg" alt="" />
          <img src="/img/li-2.svg" alt="" />
        </div>
        {adminKeyboard.adminLoginShow && (
          <AdminLoginKeyboard onClick={selCompanyIdByLoginId} onKeyPress={onKeyPress}
            layoutName={companyLoginInfo.keyboardLayout} />
        )}

        {adminKeyboard.admingLoginKeyboardShow && (
          <AdminLoginModal loginId={companyLoginInfo.companyLoginId} />
        )}

        {adminKeyboard.keyboardShow && (
          <AdminKeyboard
            companyId={companyId}
            target={"admin"}
            show={adminKeyboard.keyboardShow}
            onCallback={onKeyboardCallback}
            onClose={() => {
              setAminKeyboard(prev => ({ ...prev, keyboardShow: false }))
            }}
          ></AdminKeyboard>
        )}

        {/* {adminKeyboard.adminShow && (
          <AdminCompanyModal
            onCallback={onCallback}
            show={adminKeyboard.adminShow}
          ></AdminCompanyModal>
        )} */}
        {alertInfo.alertShow && (
          <AlertModal
            onClose={() => {
              setAlertInfo(prev => ({
                ...prev,
                alertShow: false
              }))
            }}
            title={alertInfo.title}
            content={alertInfo.content}
          ></AlertModal>
        )}

        {/* <PromotionModal key={''}></PromotionModal> */}
      </div>
    </>
  );
};

export default Main;
